import { render, staticRenderFns } from "./AccountSettingsPage.vue?vue&type=template&id=3e137447&scoped=true&"
import script from "./AccountSettingsPage.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingsPage.vue?vue&type=style&index=0&id=3e137447&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e137447",
  null
  
)

export default component.exports